// extracted by mini-css-extract-plugin
module.exports = {"Forms":"DealCardModalForm_Forms___7LvK"};